import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { pt } from 'vuetify/locale'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme: {
        colors: {
          primary: "#1F4529",
          secondary: "#F4F4F4"
        }
      }
    }
  },
  locale: {
    locale: 'pt',
    fallback: 'en',
    messages: { pt }
  }
})
